import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#icon-applicant_svg__clip0)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.00015 3.42854C8.00015 4.46463 7.13404 5.35709 6.00015 5.35709C4.86626 5.35709 4.00015 4.46463 4.00015 3.42854C4.00015 2.39246 4.86626 1.5 6.00015 1.5C7.13404 1.5 8.00015 2.39246 8.00015 3.42854ZM6.89738 6.74339C6.61103 6.81757 6.3103 6.85709 6.00015 6.85709C5.68995 6.85709 5.38917 6.81756 5.10278 6.74336C3.42979 7.12683 2.25 8.55853 2.25 10.1715C2.25 10.3529 2.3971 10.5 2.57856 10.5H9.42144C9.6029 10.5 9.75 10.3529 9.75 10.1715C9.75 8.55858 8.57028 7.12692 6.89738 6.74339ZM8.55145 5.77566C9.13976 5.16225 9.50015 4.33662 9.50015 3.42854C9.50015 1.53501 7.93315 0 6.00015 0C4.06715 0 2.50015 1.53501 2.50015 3.42854C2.50015 4.33657 2.8605 5.16215 3.44875 5.77555C1.83894 6.63451 0.75 8.28118 0.75 10.1715C0.75 11.1813 1.56867 12 2.57856 12H9.42144C10.4313 12 11.25 11.1813 11.25 10.1715C11.25 8.28126 10.1611 6.63464 8.55145 5.77566Z",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "icon-applicant_svg__clip0" }, [
        _createElementVNode("rect", {
          width: "12",
          height: "12",
          fill: "white"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }